import { render, staticRenderFns } from "./ForgotPasswordFinalize.vue?vue&type=template&id=7c984261"
import script from "./ForgotPasswordFinalize.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordFinalize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports